var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTierBg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 181 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.9969 6.53419C85.7413 3.59178 90.0001 3.59177 91.7445 6.53418L132.685 75.5909L171.054 143.857C172.921 147.178 170.077 151.173 166.328 150.495L88.6716 136.461C88.1419 136.366 87.5994 136.366 87.0698 136.461L9.41385 150.495C5.66465 151.173 2.82046 147.178 4.6872 143.857L43.0566 75.5909L83.9969 6.53419Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9538 45.7462C88.5193 44.8273 87.2119 44.8273 86.7774 45.7462L52.5653 118.1C52.1093 119.064 53.0402 120.101 54.048 119.752L87.4711 108.157C87.7266 108.068 88.0046 108.068 88.2601 108.157L121.683 119.752C122.691 120.101 123.622 119.064 123.166 118.1L88.9538 45.7462Z",
    fill: "#DEDEDE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.067 95.0874L179.001 124.916",
    stroke: "#E4E4E4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3818 12.7563L23.5092 74.9566",
    stroke: "#E4E4E4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTierBg5);
export default __webpack_public_path__ + "static/media/tier-bg-5.6dc36e5ee4c51cf2815c8afc5acd29e0.svg";
export { ForwardRef as ReactComponent };